/* eslint-disable */
const getters = {
  getUsers(state) {
    return state.data;
  },
};

export default getters;
